module.exports = __webpack_public_path__ + "img/logo_udemy.48b8d324.png";